import { render } from "./TV.vue?vue&type=template&id=123f1d0d"
import script from "./TV.vue?vue&type=script&scoped=true&lang=js"
export * from "./TV.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__